require('angular');
require('angular-route');
require('angular-sanitize');
require('angular-touch');
require('angular-cookies');
require('angular-i18n/angular-locale_fr');
require('angular-local-storage');
require('angular-ui-notification');
require('ui-bootstrap4');
require('regenerator-runtime/runtime');
require('angularindexeddb/angular-indexed-db');
require('angular-leaflet-directive');
require('Leaflet.vector-markers');
require('leaflet-gesture-handling/dist/leaflet-gesture-handling');

// less / css loading
require('./assets/less/app.less');
require('./assets/less/menu.less');
require('bootstrap/dist/css/bootstrap.css');
require('font-awesome/css/font-awesome.css');
require('datatables.net-bs4/css/dataTables.bootstrap4.css');
require('datatables.net-buttons-bs4/css/buttons.bootstrap4.css');
require('datatables.net-staterestore-bs4/css/stateRestore.bootstrap4.css')
require('datatables.net-searchbuilder-bs4/css/searchBuilder.bootstrap4.css');
require('datatables.net-responsive-bs4/css/responsive.bootstrap4.css');
require('datatables.net-select-bs4/css/select.bootstrap4.css');
require('datatables.net-datetime/dist/dataTables.dateTime.css');
require('leaflet/dist/leaflet.css');
require('Leaflet.vector-markers/dist/leaflet-vector-markers.css');
require('leaflet-gesture-handling/dist/leaflet-gesture-handling.css');

// datatable
window.$ = require('jquery');
require('datatables.net/js/jquery.dataTables');
require('datatables.net-bs4/js/dataTables.bootstrap4');
require('datatables.net-searchbuilder-bs4/js/searchBuilder.bootstrap4');
require('datatables.net-staterestore-bs4/js/stateRestore.bootstrap4');
require('datatables.net-datetime/js/dataTables.dateTime');
require('datatables.net-buttons-bs4/js/buttons.bootstrap4');
require('datatables.net-buttons/js/buttons.html5');
require('datatables.net-buttons/js/buttons.colVis');
require('datatables.net-keytable-bs4/js/keyTable.bootstrap4');
require('datatables.net-responsive-bs4/js/responsive.bootstrap4');
require('datatables.net-select-bs4/js/select.bootstrap4');
require('datatables.net-plugins/features/scrollResize/dataTables.scrollResize');
require('datatables.net-plugins/sorting/datetime-moment');
require('datatables.net-plugins/pagination/scrolling');

require('../webpack.common');
require('./modules/portal/index');
require('./modules/kya/index');
require('./modules/bdc/index');
require('./modules/prospection/index');
require('./modules/devance/index');

// TRANSFERT_COMP fonction à déplacer dans un service pour afficher les prix (généraliser, pour l'affichage des prix HT et/ou TTC)
String.prototype.toFR = function toFR() {
    let a = this;
    let b = ' ';
    let c = '',
        d = 0;
    while (a.match(/^0[0-9]/)) {
        a = a.substr(1);
    }
    for (var i = a.length-1; i >= 0; i--) {
        c = (d != 0 && d % 6 == 0) ? a[i] + b + c : a[i] + c;
        d++;
    }
    c = c.replace(/\./g, ',');
    return c;
};

// if ('serviceWorker' in navigator) {
//     console.log("registering service worker");
//     var runtime = require('serviceworker-webpack-plugin/lib/runtime');
//
//     const registration = runtime.register();
// }
let $window = angular.injector(['ng']).get('$window');

/**
 * Ajoute l'accessToken s'il est présent à toutes les requêtes
 * @param $httpProvider
 */
function accessTokenInterceptor($httpProvider) {
    $httpProvider.interceptors.push(function($q, $rootScope, $cookies, $location) {
        return {
            request: function(config) {
                if (
                    (config.url.indexOf('/api') === -1 && $rootScope.isLogin) ||
                    config.url.indexOf('/login') > -1 ||
                    config.url.indexOf('/nav') > -1
                ) {
                    // console.log('1 ', $rootScope.isLogin, config.url);
                    return config;
                }
                if (config.url.indexOf('/api') === -1 && !$rootScope.isLogin) {
                    // console.log('2 ', $rootScope.isLogin, config.url);
                    $location.path('login');
                }
                config.headers['authorization'] = 'Bearer ' + $rootScope.accessToken;
                // console.log('3 ', $rootScope.isLogin, config.url);
                return config;
            },
            response: function(config) {
                if ($cookies.get('error')) {
                    $cookies.remove('error', { path: '/' });
                    $cookies.remove('error', { path: '/bdc' });
                    $rootScope.rightError = {
                        type: 'error',
                        message: "Vous n'êtes pas autorisé à accéder à cette application. Utilisez-vous votre compte Bimedia",
                        cause: ''
                    };
                    $location.path('login');
                }
                return config;
            },
            responseError: function(resError) {
                // do something on error
                if (resError.status === 403) {
                    $cookies.remove('accessToken', { path: '/' });
                    $cookies.remove('accessToken', { path: '/bdc' });
                    $rootScope.isLogin = false;
                    $rootScope.loginError = {
                        type: 'warning',
                        message: 'Votre session a expiré. Merci de vous reconnecter.',
                        cause: ''
                    };
                    $location.path('login');
                }
                return $q.reject(resError);
            }
        };
    });
}

var assetsURL = 'https://icons.bimedia-it.com/';

var svgIcons = {
    regular: {
        Add: require('./assets/svg/regular/add.svg'),
        AlarmBell: require('../src/assets/svg/regular/alarm-bell.svg'),
        AlertDiamond: require('../src/assets/svg/regular/alert-diamond.svg'),
        AlertTriangle: require('../src/assets/svg/regular/alert-triangle.svg'),
        ArrowDown1: require('../src/assets/svg/regular/arrow-down-1.svg'),
        ArrowDown: require('../src/assets/svg/regular/arrow-down.svg'),
        ArrowLeft1: require('../src/assets/svg/regular/arrow-left-1.svg'),
        ArrowLeft: require('../src/assets/svg/regular/arrow-left.svg'),
        ArrowRight: require('../src/assets/svg/regular/arrow-right.svg'),
        ArrowRight1: require('../src/assets/svg/regular/arrow-right-1.svg'),
        ArrowUp1: require('../src/assets/svg/regular/arrow-up-1.svg'),
        ArrowUp: require('../src/assets/svg/regular/arrow-up.svg'),
        Bin: require('../src/assets/svg/regular/bin.svg'),
        Check1: require('../src/assets/svg/regular/check-1.svg'),
        CheckBadge: require('../src/assets/svg/regular/check-badge.svg'),
        Close: require('../src/assets/svg/regular/close.svg'),
        Cog: require('../src/assets/svg/regular/cog.svg'),
        InformationCircle: require('../src/assets/svg/regular/information-circle.svg'),
        Logout1: require('./assets/svg/regular/Logout-1.svg'),
        NavigationMenu: require('./assets/svg/regular/navigation-menu.svg'),
        CardPin: require('./assets/svg/regular/card-pin.svg'),
        CheckList: require('./assets/svg/regular/check-list.svg'),
        User1: require('./assets/svg/regular/user-1.svg'),
        Wallet: require('./assets/svg/regular/wallet.svg'),
        House1: require('./assets/svg/regular/house-1.svg'),
        OfficeFilePdf1: require('./assets/svg/regular/office-file-pdf-1.svg'),
        Dashboard: require('./assets/svg/regular/dashboard.svg'),
        Devance: require ('./assets/svg/regular/devance.svg'),
        RatingStar1: require ('./assets/svg/regular/rating-star-1.svg'),
        Phone: require ('./assets/svg/regular/phone.svg'),
        Filter: require('./assets/svg/regular/filter.svg'),
        Earth1: require('./assets/svg/regular/earth-1.svg'),
        Bimedia: require('./assets/svg/regular/double-check-logo-bimedia.svg'),
        Glpi: require('./assets/svg/regular/GLPI.svg'),
        PrintText: require('./assets/svg/regular/print-text.svg'),
        MenuAlt: require('./assets/svg/regular/menu-alt.svg'),
        Inbound: require('./assets/svg/regular/inbound.svg'),
        Outbound: require('./assets/svg/regular/outbound.svg'),
        Play: require('./assets/svg/regular/play.svg'),
        Stop: require('./assets/svg/regular/stop.svg'),
    }
}

angular
    .module('app', [
        'ngRoute',
        'ngSanitize',
        'ngTouch',
        'ngCookies',
        'LocalStorageModule',
        'ui-notification',
        'ui.bootstrap',
        'indexedDB',
        'leaflet-directive',
        'app.portal',
        'app.bdc',
        'app.kya',
        'app.prospection',
        'app.devance'
    ])
    .constant('Constants', {
        version: process.version,
        mode:
            document.location.href.search('localhost') !== -1 || document.location.href.search('127.0.0.1') !== -1
                ? 'dev'
                : document.location.href.search('preprod') !== -1
                    ? 'preprod'
                    : 'prod', // process.env.NODE_ENV
        iconsCDNUrl: {
            light  : assetsURL + 'icons/streamlineIcons_3.0/Streamline-Ultimate-Light/',
            regular: assetsURL + 'icons/streamlineIcons_3.0/Streamline-Ultimate-Regular/',
            bold   : assetsURL + 'icons/streamlineIcons_3.0/Streamline-Ultimate-Bold/',
            walnut : assetsURL + 'icons/walnut/'
        },
        svgIcons: svgIcons
    })
    .config([
        'orderProvider',
        'clientProvider',
        'storesGroupProvider',
        'emailProvider',
        'filesProvider',
        'userNetworkProvider',
        'agentProvider',
        'editionProvider',
        'contractProvider',
        'eulerProvider',
        'storeBackendProvider',
        'glpiBackendProvider',
        'appointmentBackendProvider',
        'authProvider',
        'walletBackendProvider',
        'userBackendProvider',
        'devanceProvider',
        'disposalBackendProvider',
        'callsBackendProvider',
        function(
            orderProvider,
            clientProvider,
            storesGroupProvider,
            emailProvider,
            filesProvider,
            userNetworkProvider,
            agentProvider,
            editionProvider,
            contractProvider,
            eulerProvider,
            storeBackendProvider,
            glpiBackendProvider,
            appointmentBackendProvider,
            authProvider,
            walletBackendProvider,
            userBackendProvider,
            devanceProvider,
            disposalBackendProvider,
            callsBackendProvider
        ) {
            userNetworkProvider.setBDCUrl(window.location.origin + window.location.pathname + 'api/');
            orderProvider.setBDCUrl(window.location.origin + window.location.pathname + 'api/');
            clientProvider.setBDCUrl(window.location.origin + window.location.pathname + 'api/');
            storesGroupProvider.setBDCUrl(window.location.origin + window.location.pathname + 'api/');
            emailProvider.setBDCUrl(window.location.origin + window.location.pathname + 'api/');
            filesProvider.setBDCUrl(window.location.origin + window.location.pathname + 'api/');
            agentProvider.setBDCUrl(window.location.origin + window.location.pathname + 'api/');
            editionProvider.setBDCUrl(window.location.origin + window.location.pathname + 'api/');
            contractProvider.setBDCUrl(window.location.origin + window.location.pathname + 'api/');
            eulerProvider.setBDCUrl(window.location.origin + window.location.pathname + 'api/');
            storeBackendProvider.setBDCUrl(window.location.origin + window.location.pathname + 'api/');
            glpiBackendProvider.setGLPIUrl(window.location.origin + window.location.pathname + 'api/');
            appointmentBackendProvider.setBDCUrl(window.location.origin + window.location.pathname + 'api/');
            walletBackendProvider.setBDCUrl(window.location.origin + window.location.pathname + 'api/');
            authProvider.setBDCUrl(window.location.origin + window.location.pathname + 'api/');
            userBackendProvider.setBDCUrl(window.location.origin + window.location.pathname + 'api/');
            devanceProvider.setBDCUrl(window.location.origin + window.location.pathname + 'api/');
            disposalBackendProvider.setBDCUrl(window.location.origin + window.location.pathname + 'api/');
            callsBackendProvider.setBDCUrl(window.location.origin + window.location.pathname + 'api/');
        }
    ])
    .config([
        '$compileProvider',
        function($compileProvider) {
            let isProd = process.env.NODE_ENV === 'production';
            $compileProvider.debugInfoEnabled(!isProd);
        }
    ])
    .config(accessTokenInterceptor)
    .directive('includeReplace', function () {
        return {
            require: 'ngInclude',
            restrict: 'A',
            link: function (scope, el) {
                el.replaceWith(el.children());
            }
        };
    })
    .run([
        '$rootScope',
        'Constants',
        function($rootScope, Constants) {
            $rootScope.version = Constants.version;
            $rootScope.mode = Constants.mode;
            $rootScope.Constants = Constants;
        }
    ]);

angular.element(document).ready(function() {
    angular.bootstrap(document, ['app']);
});
